import { CAPTURE_CONDITIONS, CAPTURE_IMAGES, CAR_MILEAGE, COMPLETE, DASHBOARD_PHOTO, SELF_INSPECTION } from '../routes/routes';
import {
    PRODUCT_COMPREHENSIVE_CAR, PRODUCT_BLING, PRODUCT_PORTABLE_POSSESSIONS, PRODUCT_CAR_WARRANTY, PRODUCT_CHILLI, SET_QUOTE_DATA, SET_IVERI_DATA, START_NEW_SALE, NEW_QUOTE_CAR, RESET_QUOTE_DATA, RESET_SELF_INSPECT_DATA, NEW_SELF_INSPECTION, RESET_SELF_INSPECTION_DATA, SET_SELF_INSPECT_DATA
} from './../constants/constants';

const initialState = {
    mileage: "",
    vinNo: "",
    regNo: "",
    licenceNo: "",
    licExpiryDate: "",
    engineNo: "",
    make: "",
    model: "",
    canSubmitSelfInspect: false,
    upholsteryDamage: "",
    paintDamage: "",
    hailDamage: "",
    carRebuilt: "",
    inspectionId: "",
    photoList: "",
    selectedPersonalCover: "",
    showSelfInspectPhotos: false,
    hasError:false
}

const selfInspectReducer = function modal(state = initialState, action) {
    switch (action.type) {
        case SELF_INSPECTION:
            return {
                initialState
            }
        case CAPTURE_IMAGES:
            return {
                addSelfInspect: action.payload
            }
        case DASHBOARD_PHOTO:
            return {
                addSelfInspect: action.payload
            }
        case CAR_MILEAGE:
            return {
                addSelfInspect: action.payload
            }
        case CAPTURE_CONDITIONS:
            return {
                addSelfInspect: action.payload
            }
        case COMPLETE:
            return {
                addSelfInspect: action.payload
            }
        case SET_SELF_INSPECT_DATA:
            return {
                ...state,

                mileage: ('mileage' in action.payload) ? action.payload.mileage : state.mileage,
                vinNo: ('vinNo' in action.payload) ? action.payload.vinNo : state.vinNo,
                regNo: ('regNo' in action.payload) ? action.payload.regNo : state.regNo,
                licenceNo: ('licenceNo' in action.payload) ? action.payload.licenceNo : state.licenceNo,
                licExpiryDate: ('licExpiryDate' in action.payload) ? action.payload.licExpiryDate : state.licExpiryDate,
                engineNo: ('engineNo' in action.payload) ? action.payload.engineNo : state.engineNo,
                make: ('make' in action.payload) ? action.payload.make : state.make,
                model: ('model' in action.payload) ? action.payload.model : state.model,
                canSubmitSelfInspect: ('canSubmitSelfInspect' in action.payload) ? action.payload.canSubmitSelfInspect : state.canSubmitSelfInspect,
                upholsteryDamage: ('upholsteryDamage' in action.payload) ? action.payload.upholsteryDamage : state.upholsteryDamage,
                paintDamage: ('paintDamage' in action.payload) ? action.payload.paintDamage : state.paintDamage,
                hailDamage: ('hailDamage' in action.payload) ? action.payload.hailDamage : state.hailDamage,
                carRebuilt: ('carRebuilt' in action.payload) ? action.payload.carRebuilt : state.carRebuilt,
                inspectionId: ('inspectionId' in action.payload) ? action.payload.inspectionId : state.inspectionId,
                photoList: ('photoList' in action.payload) ? action.payload.photoList : state.photoList,
                selectedPersonalCover: ('selectedPersonalCover' in action.payload) ? action.payload.selectedPersonalCover : state.selectedPersonalCover,
                showSelfInspectPhotos: ('showSelfInspectPhotos' in action.payload) ? action.payload.showSelfInspectPhotos : state.showSelfInspectPhotos,
                hasError: ('hasError' in action.payload) ? action.payload.hasError : state.hasError,
            }
      
        case NEW_SELF_INSPECTION:
            return {
                ...state,
                mileage: 0,
                vinNo: "",
                regNo: "",
                licenceNo: "",
                licExpiryData: "",
                engineNo: "",
                make: "",
                model: "",
                canSubmitSelfInspect: false,
                showSelfInspectPhotos: false,
                hasError: false
            }
        case RESET_SELF_INSPECTION_DATA:
            return {
                mileage: 0,
                vinNo: "",
                regNo: "",
                licenceNo: "",
                licExpiryData: "",
                engineNo: "",
                make: "",
                model: "",
                canSubmitSelfInspect: false,
                showSelfInspectPhotos: false,
                hasError: false
            }
        default:
            return state
    }
}
export default selfInspectReducer;